if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();



      
      var tlength = $('.req_field').length;
        var flength = 0;
        $('.req_field').each(function(){
            if($(this).val() != ''){
              flength++;
            }
        });

        if(tlength != flength){
         $('.reqError').show();
         return false;
        }
        else{
         $('.reqError').hide();   
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

      

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
         // setTimeout(function(){ window.location.href = '/cart';},200); 

      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

 $("input.req_field").keyup(function(){
   var disablebtn = $('.disabled-button');
  var tlength = $('.req_field').length;
        var flength = 0;
        $('.req_field').each(function(){
            if($(this).val() != ''){
              flength++;
            }
        });

        if(tlength != flength){
           $('.reqError').show();         
          disablebtn.show(); 
          disablebtn.parents('.product-form__buttons').find('button.product-form__submit[type="submit"]').hide();
          disablebtn.parents('.product-form__buttons').find('.loading-overlay__spinner').addClass('hidden');
          return false;
        }
        else{
          console.log(disablebtn)
          $('.reqError').hide();  
          disablebtn.hide(); 
          disablebtn.parents('.product-form__buttons').find('button.product-form__submit[type="submit"]').show();
          // disablebtn.parents('.product-form__buttons').find('.loading-overlay__spinner').removeClass('hidden');
        }
  });


  $(document).on('click', '.disabled-button', function(e){
    var disablebtn = $(this);
    e.preventDefault();
    $('.reqError').show();
  
  
   var tlength = $('.req_field').length;
          var flength = 0;
          $('.req_field').each(function(){
              if($(this).val() != ''){
                flength++;
              }
          });
  
          if(tlength != flength){
             $('.reqError').show();         
            disablebtn.show(); 
            disablebtn.parents('.product-form__buttons').find('button.product-form__submit[type="submit"]').hide();
            disablebtn.parents('.product-form__buttons').find('.loading-overlay__spinner').addClass('hidden');
            return false;
          }
          else{
            console.log(disablebtn)
            $('.reqError').hide();  
            disablebtn.hide(); 
            disablebtn.parents('.product-form__buttons').find('button.product-form__submit[type="submit"]').show();
            // disablebtn.parents('.product-form__buttons').find('.loading-overlay__spinner').removeClass('hidden');
          }
    
  });
    




